import React from 'react';
import { Link } from 'react-router-dom';
import { Row, Col, Button, Icon } from 'antd';

const TEAMS = [
  { key: 'ERT', name: 'Emergency Response Team', id: 'emergency-response-team', icon: 'medicine-box' },
  { key: 'CMT', name: 'Crisis Management Team', id: 'crisis-management-team', icon: 'bar-chart' },
  { key: 'IT', name: 'IT Recovery Team', id: 'information-technology-team', icon: 'desktop' }
];

const DashboardTeamAction = ({ teamPlanAccessByKey = {}, teamPlanMutedLabelByKey = {}, variant = 'default' }) => {
  const isAvivaVariant = variant === 'aviva';
  const items = TEAMS.map(team => {
    if (!isAvivaVariant) return team;
    if (team.key === 'ERT') return { ...team, name: 'Emergency | Crisis | IT Recovery Teams' };
    if (team.key === 'CMT') return { ...team, name: 'Incident Management Plan' };
    if (team.key === 'IT') return { ...team, name: 'Crisis Management Plan' };
    return team;
  });

  return (
    <Row gutter={20} type="flex" className="dashboard-team-action">
      {items.map(item => (
        <Col xs={24} sm={24} md={8} lg={8} xl={8} xxl={8} key={item.key} className="flex">
          <div
            className={`team-action-item${!teamPlanAccessByKey[item.key] ? ' team-action-item-plan-locked' : ''}`}
            data-muted-label={teamPlanMutedLabelByKey[item.key] || 'Incomplete'}
          >
            <div className="team-action-item-info">
              <div className="name">{item.name}</div>
              <Icon type={item.icon} className="icon" />
            </div>
            <div className="team-action-item-actions">
              <Link to={`/dashboard/teams#${item.id}`}>
                <Button type="link">GO TO TEAM</Button>
              </Link>
              {teamPlanAccessByKey[item.key] ? (
                <Link to={`/dashboard/plan-document#${item.id}`}>
                  <Button type="link">GO TO PLAN</Button>
                </Link>
              ) : (
                <Button type="link" disabled>
                  GO TO PLAN
                </Button>
              )}
            </div>
          </div>
        </Col>
      ))}
    </Row>
  );
};

export default DashboardTeamAction;
